var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-main-inner",
      staticStyle: { display: "flex", "flex-direction": "column" }
    },
    [
      _c("div", { staticClass: "app-main-inner-row" }, [
        _c(
          "div",
          { staticClass: "filters" },
          [
            _vm.readOnly
              ? [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.showAdd } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.treeNode && _vm.isRoot
                            ? _vm.$t("SystemMaintenance.CreateStatus")
                            : _vm.$t("SystemMaintenance.CreateStatusDetail")
                        )
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.showEdit } },
                    [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        disabled: !_vm.treeNode || _vm.isRoot
                      },
                      on: { click: _vm.toDel }
                    },
                    [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Delete")))]
                  )
                ]
              : [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.save } },
                    [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Save")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.cancel } },
                    [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Cancel")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isNew,
                          expression: "!isNew"
                        }
                      ],
                      attrs: { type: "danger" },
                      on: { click: _vm.toDel }
                    },
                    [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Delete")))]
                  )
                ]
          ],
          2
        )
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showFormCard,
              expression: "showFormCard"
            }
          ],
          staticClass: "app-main-inner-row"
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      !_vm.isNew
                        ? _vm.$t("SystemMaintenance.EditStatus")
                        : _vm.$t("SystemMaintenance.CreateStatus")
                    )
                  )
                ])
              ]),
              _c(
                "el-form",
                {
                  ref: "trackingForm",
                  staticStyle: { width: "100%" },
                  attrs: {
                    disabled: _vm.readOnly,
                    "label-position": "left",
                    "label-width": "90px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SystemMaintenance.SerialNumber") }
                    },
                    [
                      _c("el-input-number", {
                        attrs: { "controls-position": "right" },
                        model: {
                          value: _vm.trackingForm.level,
                          callback: function($$v) {
                            _vm.$set(_vm.trackingForm, "level", $$v)
                          },
                          expression: "trackingForm.level"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.Code") } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.trackingForm.code,
                          callback: function($$v) {
                            _vm.$set(_vm.trackingForm, "code", $$v)
                          },
                          expression: "trackingForm.code"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SystemMaintenance.ChineseName") }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.trackingForm.codeCname,
                          callback: function($$v) {
                            _vm.$set(_vm.trackingForm, "codeCname", $$v)
                          },
                          expression: "trackingForm.codeCname"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SystemMaintenance.EnglishName") }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.trackingForm.codeEname,
                          callback: function($$v) {
                            _vm.$set(_vm.trackingForm, "codeEname", $$v)
                          },
                          expression: "trackingForm.codeEname"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.NodeType") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "input-w",
                          attrs: { clearable: "" },
                          model: {
                            value: _vm.trackingForm.nodeType,
                            callback: function($$v) {
                              _vm.$set(_vm.trackingForm, "nodeType", $$v)
                            },
                            expression: "trackingForm.nodeType"
                          }
                        },
                        _vm._l(_vm.$constantI18n("nodeType"), function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.NodeType") } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.trackingForm.published,
                            callback: function($$v) {
                              _vm.$set(_vm.trackingForm, "published", $$v)
                            },
                            expression: "trackingForm.published"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SystemMaintenance.PublicOrNot"))
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "OFFSETDAY" } },
                    [
                      _c("el-input-number", {
                        attrs: { "controls-position": "right", min: 0 },
                        model: {
                          value: _vm.trackingForm.offsetDay,
                          callback: function($$v) {
                            _vm.$set(_vm.trackingForm, "offsetDay", $$v)
                          },
                          expression: "trackingForm.offsetDay"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "OFFSETHOUR" } },
                    [
                      _c("el-input-number", {
                        attrs: { "controls-position": "right", min: 0 },
                        model: {
                          value: _vm.trackingForm.offsetHour,
                          callback: function($$v) {
                            _vm.$set(_vm.trackingForm, "offsetHour", $$v)
                          },
                          expression: "trackingForm.offsetHour"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_QuicklyConfigureSettings")
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.trackingForm.quickConfiguration,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.trackingForm,
                                "quickConfiguration",
                                $$v
                              )
                            },
                            expression: "trackingForm.quickConfiguration"
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "CargoMsg.Cargo_QuickConfigurationIsCheckedByDefault"
                                )
                              )
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SystemMaintenance.Remark") } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", rows: 3 },
                        model: {
                          value: _vm.trackingForm.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.trackingForm, "remark", $$v)
                          },
                          expression: "trackingForm.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }